export default __webpack_public_path__ + "static/media/logo.f929412b.svg";